module.exports =
  '_GROUP':
    'TITLE': "Group"
    'PAGE_TITLE': "Group Registration"
    'CREATE_GROUP': 'Create Group'
    'CUSTOMIZE_GROUP': 'Customizing The Group'
    'ADD_IMAGE': 'Add Image'
    'UPLOAD_PHOTO': 'Upload Photo'
    'SELECT_PHOTO': 'Select Photo'
    'GROUP_ICON_TITLE': 'Group Icon'
    'GROUP_ICON': 'Group Icon'
    'GROUP_NAME': 'Group Name'
    'ABOUT_GROUP': 'About This Group'
    'ABOUT_GROUP_DETAIL': 'About This Group'
    'PRIVACY_SETTINGS': 'Privacy Settings'
    'PRIVATE_GROUP': 'Closed'
    'PRIVATE_GROUP_DES': 'Only members can see.'
    'PUBLIC_GROUP': 'Public'
    'PUBLIC_GROUP_DES': 'Anyone can see the group.'
    'TITLE_CANCEL': 'Cancel'
    'TITLE_CREATE': 'Create'
    'NO_DATA': 'No Data.'
    'IN_PREPARE': 'Currently being prepared.'
    'EDIT':
      'PAGE_TITLE': 'Group Edit'
      'CHANGE_COVER': 'Change Image'
      'CHANGE_ICON': 'Change Icon'
      'TITLE_SAVE': 'Save'
    'LIST':
      'PAGE_TITLE': "Group List"
      'CREATE_GROUP': 'Create New group'
      'SEARCH_GROUP': 'Searching group'
      'LIST_GROUP': '参加グループ'
      'PUBLIC_GROUP': 'Public'
      'PRIVATE_GROUP': 'Closed'
      'MEMBERS': 'Members'
      'MEMBERS_EXT': ''
      'EDIT_GROUP': 'Edit/Setting'
      'COPY_GROUP': 'Copy the Invitation URL'
    'TOOLBAR':
      'JOINED': 'Joined'
      'LEAVE_GROUP': 'Leave Group'
      'INFORMATION': 'Information'
      'REQUEST': 'Request'
      'IN_REQUEST': 'In request'
      'INVITATION': 'Invitation'
      'EDIT_MEMBER': 'Edit Member'
      'NOT_ALLOWED_LEAVE_GROUP': 'You can not change because of the Group Administrator for absence.'
      'CONFIRM_MESS_LEAVE_GROUP': 'Are you sure you want to leave this group?'
      'REQUEST_MESS_JOIN_GROUP': 'Your request has been sent to the Group administrator.'
      'COPY_MESS_URL': 'Copied the URL.'
    'DETAIL_TABS':
      'TIMELINE': 'Timeline'
      'EVENT': 'Event'
      'RANKING':'Ranking'
    'SEARCH':
      'JOINED_GROUP_LIST' : 'Joined group list'
      'SEARCH_RESULTS': 'Search results'
      'JOINED': 'Joined'
    'CROP':
      'TITLE': 'Crop'
      'CANCEL': 'Cancel'
      'DONE': 'Done'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/i18n/en.coffee